import script from "./LockStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./LockStudents.vue?vue&type=script&setup=true&lang=js"

import "./LockStudents.vue?vue&type=style&index=0&id=336c11da&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336c11da"]])

export default __exports__